define(function (require) {

    window.lpTag = window.lpTag || {};

    var lpAgentConfig = require('web-agent-config/lpAgentConfig');
    var ViewController = require('web-agent-framework/ViewController');
    // var MainViewController = require('web-agent-viewControllers/MainViewController');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var AgentShortcutPopup = require('web-agent-viewControllers/AgentShortcutPopup');

    var AgentShortcutsManager = function () {
        AgentShortcutsManager.applicationType = "AgentShortcutsManager";
        var logger = WebAgentLogger.getLogger(this.applicationType);

        var KEYBOARD_KEY = 192; // ~ key for triggering the shortcut
        var KEYBOARD_MODIFIER = 17; // Ctrl key
        var shortcuts = {};
        var customShortcutsList;
        var parentMenuKeyCode;
        var shortcutTriggered = false;
        var that = this;

        var SHIFT = 16;
        var ALT = 18;
        var UP = 38;
        var DOWN = 40;

        var selectedClass = "selected";

        var popupDataBinder = {
            rowClicked: lineClicked,
            rowSelected: lineHighlighted,
            operationCanceled: hidePopup
        };

        var popupTexts = {
            title: agentLEManager.translateLE("LEWebAgent.hotkeysTitle"),
            description: agentLEManager.translateLE("LEWebAgent.hotkeysDescription")
        };

        if (document.body.addEventListener) {
            document.body.addEventListener("keyup", keyUp, false);
            document.body.addEventListener("keydown", keyDown, false);
        } else if (document.body.attachEvent) {
            document.body.attachEvent("onkeyup", keyUp);
            document.body.attachEvent("onkeydown", keyDown);
        }

        that.register = function (type, callback, tooltipView, context) {
            if (typeof callback !== 'function') {
                return;
            }

            if (type.constructor === Array) {
                for (var i = 0; i < type.length; i++) {
                    singleRegister(type[i], callback, tooltipView, context);
                }
            } else {
                singleRegister(type, callback, tooltipView, context);
            }
        };

        function singleRegister(type, callback, tooltipView, context) {
            that.unregister(type, callback, context);
            var array = shortcuts[type.type];
            if (!array) {
                array = shortcuts[type.type] = [];
            }
            array.push({type: type, callback:callback, context:context, tooltipView:tooltipView});

            if (that.popupView && that.popupView.visible) {
                var shortcutsData = getShortcutsData();
                that.popupView.updateModelData(shortcutsData);
                if (that.popupView.visible) {
                    showHotkeyTooltips();
                }
            }
        }

        that.unregister = function (type, callback, context) {
            if (type.constructor === Array) {
                for (var i = 0; i < type.length; i++) {
                    singleUnregister(type[i], callback, context);
                }
            } else {
                singleUnregister(type, callback, context);
            }

        };

        function singleUnregister(type, callback, context) {
            var array = shortcuts[type.type];
            if (array) {
                //rebuilding the array without the requested instance
                var index = -1;
                for (var i = 0; i < array.length; i++) {
                    if (array[i].callback === callback && array[i].context === context) {
                        index = i;
                    }
                }
                if (index >= 0) {  // Hiding the tooltip for the unregistered shortcut.
                    if (array[index].tooltipView) {
                        array[index].tooltipView.style.display = 'none';
                    }
                    array.splice(index, 1);
                }
                if (array.length === 0) {
                    shortcuts[type.type] = null;
                    delete shortcuts[type.type];
                }
            }
            if (that.popupView && that.popupView.visible) {
                that.popupView.updateModelData(getShortcutsData());
            }
        }

        that.trigger = function (key, e) {
            var shortcutsData = customShortcutsList || shortcuts;

            for (var prop in shortcutsData) {
                if (shortcutsData.hasOwnProperty(prop)) {
                    var shortcutObject = shortcutsData[prop][0].type;
                    if (key === shortcutObject.shortcutChar) {
                        return triggerByType(shortcutsData[prop], {event : e, parentKeyCode : parentMenuKeyCode});
                    }
                }
            }
        };

        function triggerByType(array, e) {
            var lastShortcut = array[array.length - 1];
            try {
                logger.info(lastShortcut.type, "triggerByType");
                return lastShortcut.callback.call(lastShortcut.context || that, e);
            } catch (ex) {
                logger.error(lastShortcut.type, "triggerByType");
                // REMOVE_BEFORE_PRODUCTION_START
                if (lpAgentConfig && lpAgentConfig.throwExceptions) {throw ex;}
                // REMOVE_BEFORE_PRODUCTION_END
            }
        }

        function keyDown(e) {
            e = e || event;
            var keyCode = e.keyCode || e.which;

            if (shortcutTriggered) {
                ViewController.prototype.preventDefault(e);
                ViewController.prototype.stopPropagation(e);
                ViewController.prototype.touchSession();
                return;
            }

            if (keyCode !== SHIFT && keyCode !== ALT) { // In general shift can be part of the shortcut.
                if (keyCode == KEYBOARD_KEY || keyCode == KEYBOARD_MODIFIER) {
                    if (keyCode === KEYBOARD_KEY) {
                        that.shortcutKeyClicked = true;
                    } else {
                        that.shortcutModifierClicked = true;
                    }
                    if (that.shortcutKeyClicked && that.shortcutModifierClicked) {
                        shortcutTriggered = true;
                        clearPopupTimeout();
                        that.popupTimeout = setTimeout(function () {
                            popupShortcutDialog();
                        }, 700);
                    }
                } else if (!shortcutTriggered) {
                    clearPopupTimeout();
                    hidePopup();
                }
            }
        }

        function keyUp(e) {
            e = e || event;
            var keyCode = e.keyCode || e.which;

            var shouldTrigger = true; // Triggering on ` key from the second click, the first is assumed for

            switch (keyCode) {
                case KEYBOARD_KEY :
                case KEYBOARD_MODIFIER :
                    shouldTrigger = onModifierKey(keyCode);
                    break;
                case SHIFT :
                case UP :
                case DOWN :
                    shouldTrigger = false;
                    break;
            }

            if (shortcutTriggered && shouldTrigger) {
                triggerShortcut();

            }

            function triggerShortcut() {
                clearPopupTimeout();
                var continueTableData = that.trigger(String.fromCharCode(keyCode), e);

                if (typeof continueTableData === 'undefined') { // If we did not receive a continuance data.
                    hidePopup();
                } else if (continueTableData.types) { // If the continuance table has types in it
                    hideHotkeyTooltips();
                    parentMenuKeyCode = keyCode;
                    customShortcutsList = {};
                    for (var i = 0 ; i < continueTableData.types.length ; i++) {
                        var value = {type : continueTableData.types[i], callback : continueTableData.callback, context : continueTableData.context};
                        customShortcutsList[continueTableData.types[i].type] = [value];
                    }

                    if (that.popupView) {
                        that.popupView.updateModelData(getShortcutsData());
                    }
                }
                ViewController.prototype.preventDefault(e);
                ViewController.prototype.stopPropagation(e);
                ViewController.prototype.touchSession();
            }

            /**
             * If the key is one of the modifiers AKA Ctrl ` then we figures if both are released or not,
             * If not both released and the released is the ` so we trigger (from second release) for toggling
             * @param keyCode
             * @return {Boolean}
             */
            function onModifierKey(keyCode) {
                var shouldTriggerShortcuts = true;

                if (keyCode === KEYBOARD_KEY) {
                    // On first release we do not trigger the ` char, but we will use it for toggling afterward
                    shouldTriggerShortcuts = !that.shortcutKeyClicked || e.shiftKey;
                    that.shortcutKeyClicked = false;
                    if (shouldTriggerShortcuts) {
                        that.periodicKeyboardKeyClicked = true;
                    }
                } else {
                    shouldTriggerShortcuts = false;
                    that.shortcutModifierClicked = false;
                }

                if (!that.shortcutKeyClicked && !that.shortcutModifierClicked && that.periodicKeyboardKeyClicked) {
                    that.periodicKeyboardKeyClicked = false;
                    clearPopupTimeout();
                    hidePopup();
                }

                return shouldTriggerShortcuts;
            }
        }

        function clearPopupTimeout() {
            if (that.popupTimeout) {
                clearTimeout(that.popupTimeout);
                that.popupTimeout = null;
            }
        }

        function clearHidePopupTimeout() {
            if (that.hidePopupTimeout) {
                clearTimeout(that.hidePopupTimeout);
                that.hidePopupTimeout = null;
            }
        }

        function createHidePopupTimeout() {
            clearHidePopupTimeout();
            that.hidePopupTimeout = setTimeout(function () {
                hidePopup();
            }, 10000);
        }

        function lineHighlighted(data) {
            createHidePopupTimeout();

            if (that.selectedTooltipView && that.selectedTooltipView.firstChild) {
                ViewController.prototype.removeClass(that.selectedTooltipView.firstChild, selectedClass);
            }
            that.selectedTooltipView = data.tooltipView;

            if (that.selectedTooltipView && that.selectedTooltipView.firstChild) {
                ViewController.prototype.addClass(that.selectedTooltipView.firstChild, selectedClass);
            }
        }

        function lineClicked(data) {
            keyUp({keyCode: data.rowData.shortcutChar.charCodeAt(0)});
        }

        function popupShortcutDialog() {
            logger.info("agent shortcut triggered", "popupShortcutDialog");

            var shortcutsData = getShortcutsData();
            if (shortcutsData.length === 0) {
                return;
            }

            if (!that.popupView) {
                that.popupView = new AgentShortcutPopup({
                    templateFile: "LP_hotkey.html",
                    dataBinder: popupDataBinder,
                    textInjection: popupTexts
                });
                window.MainViewControllerBody.appendChild(that.popupView.view);
            } else {
                that.popupView.lpShow();
            }
            that.popupView.updateModelData(shortcutsData);

            showHotkeyTooltips();
            createHidePopupTimeout();
        }

        function hidePopup() {
            clearHidePopupTimeout();

            customShortcutsList = null;
            shortcutTriggered = false;
            that.shortcutKeyClicked = false;
            that.shortcutModifierClicked = false;

            if (that.popupView && that.popupView.visible) {
                that.popupView.lpHide();
                hideHotkeyTooltips();
            }
        }

        function getShortcutsData() {

            var shortcutsData = customShortcutsList || shortcuts;
            var arrays = [[]]; // Array of sections (another array)

            for (var prop in shortcutsData) {
                if (shortcutsData.hasOwnProperty(prop)) {
                    if (!shortcutsData[prop][0].type || (shortcutsData[prop][0].type && !shortcutsData[prop][0].type.hidden)) {
                        var shortcutObject = shortcutsData[prop][0].type;
                        var shortcutChar = shortcutObject.shortcutChar || shortcutsData[prop][0].shortcutChar;
                        var index = -1;
                        for (var i = 0; i < arrays[0].length; i++) {
                            if (arrays[0][i].shortcutChar == shortcutChar) {
                                index = i;
                            }
                        }
                        if (index >= 0) {
                            arrays[0].splice(index, 1);
                        }

                        var sectionIndex = AgentShortcutsManager.shortcutType[shortcutObject.type] ? 0 : 1;
                        if (sectionIndex >= arrays.length) {
                            arrays.push([]); // Adding another section.
                        }

                        var type = agentLEManager.translateLE("LEWebAgent." + shortcutObject.description) || shortcutObject.description;
                        var tooltip = type;
                        if (shortcutObject.tooltip !== undefined) {
                            tooltip = agentLEManager.translateLE("LEWebAgent." + shortcutObject.tooltip);
                        }

                        arrays[sectionIndex].push({
                            type: type,
                            shortcutChar: shortcutChar,
                            hotkey: shortcutObject.hotkey || shortcutChar,
                            tooltipView: shortcutsData[prop][shortcutsData[prop].length - 1].tooltipView,
                            tooltip: tooltip
                        });
                    }
                }
            }
            return arrays;
        }

        function showHotkeyTooltips() {
            if (customShortcutsList) {
                hideHotkeyTooltips();
            } else {
                for (var prop in shortcuts) {
                    var array = shortcuts[prop];
                    for (var index = 0; index < array.length; index++) {
                        if (array[index].tooltipView) {
                            array[index].tooltipView.style.display = 'block';
                        }
                    }
                }
            }
        }

        function hideHotkeyTooltips() {
            if (that.selectedTooltipView && that.selectedTooltipView.firstChild) {
                ViewController.prototype.removeClass(that.selectedTooltipView.firstChild, selectedClass);
            }

            for (var prop in shortcuts) {
                var array = shortcuts[prop];
                for (var index = 0; index < array.length; index++) {
                    if (array[index].tooltipView) {
                        array[index].tooltipView.style.display = 'none';
                    }
                }
            }
        }
    };

    AgentShortcutsManager.shortcutType = {
        ACCEPT_NEXT_CHAT: {
            type: "ACCEPT_NEXT_CHAT",
            description: "hotkeyDescriptionAcceptNextChat",
            shortcutChar: 'A'
        },
        //VISITOR_INFORMATION: {
        //    type: "VISITOR_INFORMATION",
        //    description: "hotkeyDescriptionVisitorInformation",
        //    shortcutChar: 'K'
        //},
        STATUS_WIDGET: {
            type: "STATUS_WIDGET",
            description: "hotkeyDescriptionStatusWidget",
            shortcutChar: 'S'
        },
        CLOSE_ENGAGEMENT: {
            type: "CLOSE_ENGAGEMENT",
            description: "hotkeyDescriptionCloseEngagement",
            shortcutChar: 'X'
        },
        TRANSFER_ENGAGEMENT: {
            type: "TRANSFER_ENGAGEMENT",
            description: "hotkeyDescriptionTransferEngagement",
            shortcutChar: 'T'
        },
        TRANSFER_CONVERSATION: {
            type: "TRANSFER_CONVERSATION",
            description: "hotkeyDescriptionTransferConversation",
            shortcutChar: 'T'
        },
        LOGOUT: {
            type: "LOGOUT",
            description: "hotkeyDescriptionSignout",
            shortcutChar: 'L',
            tooltip: "hotkeyDescriptionSignoutTooltip"
        },
        CLOSED: {
            type: "CLOSED",
            description: "hotkeyDescriptionClosedList",
            shortcutChar: 'C',
            tooltip: "hotkeyClosedListTooltip"
        },
        NEXT_TO_TAKE_ACTION: {
            type: "NEXT_TO_TAKE_ACTION",
            description: "hotkeyDescriptionNextToTakeAction",
            shortcutChar: 'N',
            tooltip: "hotkeyDescriptionNextToTakeAction"
        },
        FOCUS_TOGGLING_NEXT: {
            type: "FOCUS_TOGGLING_NEXT",
            description: "hotkeyDescriptionNextActiveEngagement",
            shortcutChar: String.fromCharCode(192),
            hotkey: "Ctrl-`",
            hidden: true
        },
        FOCUS_TOGGLING_BACK: {
            type: "FOCUS_TOGGLING_BACK",
            description: "hotkeyDescriptionPrevActiveEngagement",
            shortcutChar: '~',
            hotkey: "Ctrl-Shift-`",
            hidden: true
        },
        LIST_VIEW: {
            type: "LIST_VIEW",
            description: "hotkeyDescriptionListView",
            shortcutChar: 'V',
            tooltip: "hotkeyListViewTooltip"
        },
        HIDE_CONVERSATION: {
            type: "HIDE_CONVERSATION",
            description: "hotkeyDescriptionHideConversation",
            shortcutChar: 'H',
            tooltip: "hotkeyDescriptionHideConversationTooltip"
        },
        CLOSE_CONVERSATION: {
            type: "CLOSE_CONVERSATION",
            description: "hotkeyDescriptionCloseConversation",
            shortcutChar: 'X',
            tooltip: "hotkeyDescriptionCloseConversationTooltip"
        },
        RETURN_TO_QUEUE: {
            type: "RETURN_TO_QUEUE",
            description: "hotkeyDescriptionReturnToQueue",
            shortcutChar: 'Q',
            tooltip: "hotkeyDescriptionReturnToQueueTooltip"
        }
    };

    return AgentShortcutsManager;

});
